<template>
  <div id="refactor-case">
    <header-menu></header-menu>
    <div style="margin-top: 80px;"><img src="https://cdn.huimiaokeji.com/bj_kh@2x.png" alt="图片" style="width: 100%;"></div>
    <div class="refactor-container">
      <div class="refactor-grid-container">
        <div
            v-for="(item, index) in displayList"
            :key="index"
            class="refactor-grid-item"
        >
          <!-- 封面图 -->
          <img
              class="cover-image"
              :src="item.coverImage"
              alt="封面图"
          >
          <!-- 标题 -->
          <h3 class="title">{{ item.title }}</h3>
          <div style="width: 32px;height: 4px;background: #0B00B5;margin-bottom: 8px;"></div>
          <!-- 摘要 -->
          <p class="summary">{{ item.summary }}</p>
          <div class="more-item" @click="goToDetails(item.caseId+':4')">
            <div class="custom-button">MORE</div>
          </div>
        </div>
      </div>
      <!-- 查看更多按钮 -->
      <div v-if="caseList.length > 9 && !showAllItems" class="load-more-container">
        <button class="load-more-button" @click="showMoreItems">
          查看更多
        </button>
      </div>
    </div>
    <footer-menu
        title="使用轻变聚合领先的智能变现工具，开启您的增收之旅"
        buttonText="马上合作"
        buttonLink="https://admin.huimiaokeji.com"
    ></footer-menu>
    <floating-modal ref="floatingModal"></floating-modal>
  </div>
</template>

<script>
import { getCaseList } from '../../api/index.js';
import FooterMenu from '../../components/footer-menu.vue';
import HeaderMenu from "../../components/header-menu.vue";
import FloatingModal from "~/components/floating-modal.vue";
import {aes} from "~/utils/crypto";

export default {
  name: 'Case',
  components: {
    FloatingModal,
    HeaderMenu,
    FooterMenu
  },
  data() {
    return {
      caseList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 100,
      },
      showAllItems: false // 控制是否显示所有数据
    }
  },
  computed: {
    displayList() {
      if (this.showAllItems) {
        return this.caseList;
      } else {
        return this.caseList.slice(0, 9);
      }
    }
  },
  created() {
    document.title = '灰鲸网络-客户案例';
    this.queryCaseList();
  },
  methods: {
    goToDetails(caseId) {
      const encrypted = aes.encrypt(caseId);
      const url = `https://www.huimiaokeji.com/refactorDetails?infoId=${encodeURIComponent(encrypted)}`;
      window.open(url, '_blank');
    },
    async queryCaseList() {
      let res = await getCaseList();
      if (res.code == 200) {
        this.caseList = res.data || []
      }
    },
    // 显示更多内容的方法
    showMoreItems() {
      this.showAllItems = true;
    }
  }
}
</script>

<style lang="less">
#refactor-case {
  background-color: #FFFFFF;

  .refactor-container {
    max-width: 1280px; /* 根据设计需求调整 */
    margin: 0 auto; /* 居中显示 */
    padding: 100px 40px 50px 40px; /* 防止贴边 */
  }

  .refactor-grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    /* 动态间隙：小屏幕20px，大屏幕最大30px */
    gap: clamp(30px, 2vw, 40px);

    /* 或者固定间隙（任选其一） */
    /* gap: 24px; */

    /* 手机端响应式布局 */
    @media (max-width: 980px) {
      grid-template-columns: repeat(2, 1fr);
      margin-left: -15px;
    }
  }

  .refactor-grid-item {
    /* 限制项目最大宽度（可选） */
    width: 366px;
    height: 403px;
    // width: 100%;
    cursor: pointer;

    /* 保持项目比例 */
    aspect-ratio: 1/1;
    background: #ffffff;
    border-radius: 2px;
    margin-bottom: 30px;
    //box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    /* 居中内容 */
    display: flex;
    flex-direction: column;
    padding: 16px; /* 添加内边距 */
    /* 手机端响应式布局 */
    @media (max-width: 980px) {
      width: 430px;
      padding: 10px; /* 添加内边距 */
    }
    /* 封面图样式 */

    .cover-image {
      width: 100%; /* 继承父容器宽度 */
      height: 225px; /* 固定高度 */
      object-fit: cover; /* 保持图片比例 */
      border-radius: 2px 2px 0 0; /* 圆角小于父容器 */
      margin-bottom: 12px; /* 图片和标题间距 */
    }

    /* 标题样式 */

    .title {
      font-size: 18px;
      color: #333;
      margin: 0 0 8px 0; /* 下边距8px */

      /* 单行省略号 */
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-top: 10px;
      //padding-left: 16px;
      padding-right: 16px;
    }

    /* 摘要样式 */
    .summary {
      font-size: 14px;
      color: #5D5454;
      //padding: 0 16px;
      margin: 0;
      line-height: 1.5; /* 假设行高是字体大小的1.5倍 */

      /* 三行省略号核心代码 */
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3; /* 显示3行 */
      overflow: hidden;
      text-overflow: ellipsis;
      /* 精确设置固定高度（3行 x 行高） */
      height: calc(14px * 1.5 * 3);
      /* 精确计算最大高度（3行 x 行高） */
      //max-height: calc(1em * 1.5 * 3); /* 14px * 1.5 * 3 = 63px */
      word-break: break-word;
      /* 跨浏览器兼容方案 */
      display: -moz-box;
      -moz-box-orient: vertical;
      -moz-line-clamp: 3;
      display: -ms-flexbox;
      -ms-line-clamp: 3;
      line-clamp: 3;
    }

    .more-item {
      height: 30px;
      margin: 20px 0; /* 调整上下间距为20px */
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .custom-button {
        width: 66px;
        height: 30px;
        color: #FFFFFF;
        background: #0B00B5;
        border-radius: 16px;
        /* 添加以下属性使文字居中 */
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
  /* 查看更多按钮样式 */
  .load-more-container {
    margin-top: 40px;
    display: flex;
    justify-content: center;
  }

  .load-more-button {
    padding: 10px 30px;
    font-size: 16px;
    color: #0B00B5;
    background: #FFFFFF;
    border: 1px solid #0B00B5;
    border-radius: 25px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .load-more-button:hover {
    background: #0B00B5;
    color: #FFFFFF;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/refactor/Case.vue